/*  ========================================================================
    # Hooks - Use Hero Slider Pagination
    ========================================================================  */

import { useCallback, useState } from 'react';

export default function useHeroSliderPagination(slidesCount = 1) {
  const [index, setIndex] = useState(0);

  // Jump to next slide. If at the end, jump back to 0.
  const goNext = useCallback(() => {
    setIndex(index >= slidesCount - 1 ? 0 : index + 1);
  }, [setIndex, index, slidesCount]);

  // Jump to previous slide. If at the beginning, jump back up to the last index.
  const goPrev = useCallback(() => {
    setIndex(index > 0 ? index - 1 : slidesCount - 1);
  }, [setIndex, index, slidesCount]);

  // Return the current index and the stepping handlers
  return [index, goNext, goPrev];
}
